import { Box, styled } from '@mui/material'
import { ProgressLoaders } from 'components'
import { SkipLink } from 'components/ui/SkipLink'
import { color } from 'config/color'
import { useAuth } from 'context'
import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import { SideBar, TopBar } from './component'

export const AuthorizedLayout: React.FC = () => {
  const location = useLocation()
  const { isLoading } = useAuth()
  const isMobile = useMobileBreakpoints()

  useEffect(() => {
    const mainContentElement = document.getElementById('main-content')
    if (mainContentElement != null) {
      mainContentElement.scrollTop = 0
    }
  }, [location])

  if (isLoading) {
    return (
      <Box>
        <ProgressLoaders height="100vh" />
      </Box>
    )
  }

  return (
    <Main aria-label="Main content">
      <SkipLink targetId="main-content">Skip to main content</SkipLink>
      <SideBar />
      <TopBar />
      <MainContent
        id="main-content"
        mt={isMobile ? 0 : '200px'}
        tabIndex={-1}
        component="section"
        aria-label="Page content"
      >
        <Box padding={3} mt={isMobile ? 0 : 2}>
          <Outlet />
        </Box>
      </MainContent>
    </Main>
  )
}

const Main = styled('main')({
  background: color.white,
  overflow: 'hidden',
  position: 'relative',
  minHeight: '100vh'
})

const MainContent = styled(Box)`
  background: ${color.background[400]};
  overflow: auto;

  @media screen and (min-width: 1200px) {
    margin-left: auto;
    width: calc(100% - 240px);
    height: calc(100vh - 200px);
  }
`
